import { Cog, Minus, Moon, Plus, Sun } from "lucide-react"
import { Button } from "../ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu"
import { useStore } from "@tanstack/react-store"
import { themeStore } from "@/stores/theme-store"
import { Switch } from "../ui/switch"
import { Label } from "../ui/label"

const fontSizes = ["font-size-sm", "font-size-md", "font-size-lg", "font-size-xl"] as const

const ThemeManager = () => {
  const { theme, size: storeSize, chargeLayout } = useStore(themeStore)
  const size = storeSize || "font-size-md" // Default to medium size if not set
  const setTheme = (theme: string) => {
    themeStore.setState((state) => ({ ...state, theme }))
    localStorage.setItem("theme", theme)
    document.documentElement.classList.remove("dark", "light")
    document.documentElement.classList.add(theme)
  }

  const setSize = (newSize: typeof fontSizes[number]) => {
    themeStore.setState((state) => ({ ...state, size: newSize }))
    document.documentElement.classList.remove(...fontSizes)
    document.documentElement.classList.add(newSize)
  }

  const increaseSize = () => {
    const idx = fontSizes.indexOf(size as typeof fontSizes[number])
    if (idx < fontSizes.length - 1) setSize(fontSizes[idx + 1])
  }

  const decreaseSize = () => {
    const idx = fontSizes.indexOf(size as typeof fontSizes[number])
    if (idx > 0) setSize(fontSizes[idx - 1])
  }

  const themeSizeLabel: Record<typeof fontSizes[number], string> = {
    "font-size-sm": "کوچک",
    "font-size-md": "متوسط",
    "font-size-lg": "بزرگ",
    "font-size-xl": "بسیار بزرگ",
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost">
          <Cog />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-64">
        <DropdownMenuLabel>تنظیمات تم</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <Button variant="ghost" onClick={() => setTheme(theme === "dark" ? "light" : "dark")}>
          {theme === "dark" ? 
          <>
          <Moon className="size-6 ml-1" />
          تبدیل به روشن
          </>
           : 
           <>
           <Sun className="size-6 ml-1" />
           تبدیل به تاریک
           </>
           }
        </Button>

        <DropdownMenuSeparator />
        <DropdownMenuLabel>اندازه متن</DropdownMenuLabel>
        <div className="flex justify-between items-center">
          <Button size="icon" variant="ghost" onClick={decreaseSize}>
            <Minus />
          </Button>

          <span className="font-size-sm">{themeSizeLabel[size as keyof typeof themeSizeLabel]}</span>

          <Button size="icon" variant="ghost" onClick={increaseSize}>
            <Plus />
          </Button>
        </div>

        <DropdownMenuSeparator />
        <DropdownMenuLabel>
          مدل نمایش شارژ
        </DropdownMenuLabel>
        <div className="p-2">
          <Label className="flex gap-2 items-center ">

          <Switch checked={chargeLayout == 'new'} onCheckedChange={(e) => {
            if (e) {
              themeStore.setState((state) => ({...state, chargeLayout: 'new'}))
            } else {
              themeStore.setState((state) => ({...state, chargeLayout: 'old'}))
              
            }
          }}/>
          تم جدید
          </Label>
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default ThemeManager
